import React from 'react';
import { getReleaseVersion } from './config/config';
import { useDataLoader } from '../hooks/use-data-loader';

export type VersionData = {
  version: string;
  metadata: {
    gitHash: string;
    gitBranch: string;
  };
};

export const APP_VERSION_KEY = 'app-version';
const NO_VERSION = 'unknown';

export const isAppOutdated = (version: string) => version !== NO_VERSION && localStorage.getItem(APP_VERSION_KEY) !== version;

export const hardRefresh = () => {
  const url = new URL(window.location.href);

  const params = new URLSearchParams(url.search);
  params.set('appUpdater', Date.now().toString());

  url.search = params.toString();

  window.location.replace(url.toString());
};

const getServerVersion = async () => {
  try {
    const versionData = await fetch(`./version.json?t=${Date.now()}`);
    const versionJson: VersionData = await versionData.json();
    return versionJson.version;
  } catch (e) {
    return NO_VERSION;
  }
};

export const useAppServerVersion = () => {
  const fetchVersion = React.useCallback((token: string, signal: AbortSignal) => getServerVersion(), []);
  const versionLoader = useDataLoader(fetchVersion);

  return {
    ...versionLoader,
    data: versionLoader.data ?? getReleaseVersion(),
  };
};
